<template>
  <div class="odd:bg-gray-100 border border-gray-200 rounded px-4 flex-1 text-sm">
    <div class="flex -mx-4 justify-between items-center">
      <div class="w-24 px-3">
        <RouterLink
          :to="{ name: 'accounts.show', params: { accountId: account.id } }"
          class="capitalize"
        >
          <template v-if="account.logo">
            <img :src="account.logo" class="block rounded w-full" />
          </template>
          <template v-else>
            <div class="aspect-ratio-square w-full rounded bg-gray-200" />
          </template>
        </RouterLink>
      </div>
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="flex-1 px-4">
            <h5 class="text-sm">
              {{ accountSubscription.name }}
            </h5>
            <p v-if="account" class="text-gray-600">
              {{ account.name }}
            </p>
          </div>

          <div class="w-32 px-4 mt-4 lg:mt-0">
            {{ dateStart }}
          </div>

          <div class="w-32 px-4 mt-4 lg:mt-0 lg:text-right">
            {{ accountSubscription.billingAmount }} &euro;
          </div>

          <div class="w-32 px-4 mt-4 lg:mt-0 lg:text-right">
            {{ accountSubscription.minCharges || 0 }} &euro;
          </div>

          <div class="hidden lg:block w-32 lg:text-right px-4">
            {{ accountSubscription.dateCreated }}
          </div>
        </div>
      </div>

      <div class="flex-none pr-4">
        <button
          :disabled="!accountSubscription.can.view || disabled"
          class="w-10 h-10 px-4 py-2 rounded text-blue-600 hover:bg-blue-600 hover:text-white focus:outline-none disabled:text-gray-600 disabled:bg-transparent"
          @click="$emit('account-subscription:view', accountSubscription)"
        >
          <FontAwesomeIcon icon="chevron-right" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapState } from 'vuex';

export default {
  props: {
    accountSubscription: { type: Object, required: true },
    disabled: Boolean,
  },

  computed: {
    ...mapState('entities', {
      account({ accounts }) {
        return accounts.byId[this.accountSubscription.accountUuid] || null;
      },
    }),
    dateStart() {
      return moment(this.accountSubscription.dateStart).format('DD/MM/YYYY');
    },
  },
};
</script>
